import React from 'react';

import ShowOnly from '../ShowOnly';

const minBreakpoint = 'header-reduce-word';

export default ({ children }) => (
  <ShowOnly minBreakpoint={minBreakpoint}>
    &nbsp;
    {children}
  </ShowOnly>
);
